



































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class SubMenuNavigationDrawrer extends Vue {
  private menuIconSize: number = 17;
  private cardWidth: string = '240px';
  private cardElevation: number = 1;

  private menuContentFields: Array<{
    title: string;
    icon: string;
    routeName: string;
  }> = [
    {
      title: '基本設定',
      icon: 'cog-outline',
      routeName: 'projectConfigBasic',
    },
    {
      title: '課題属性',
      icon: 'folder-cog',
      routeName: 'projectConfigTaskAttribute',
    },
    {
      title: 'テーマ',
      icon: 'brightness-4',
      routeName: 'projectConfigTheme',
    },
    {
      title: 'Git',
      icon: 'git',
      routeName: 'projectConfigGit',
    },
    {
      title: 'インテグレーション',
      icon: 'handshake-outline',
      routeName: 'projectConfigIntegration',
    },
  ];

  private selectedMenu(routeName: string) {
    if (routeName === this.$route.name) {
      return 'selected-menu';
    }
  }
}
